import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
// Inter, actually shipped. Imported FIRST so the @font-face declarations exist before any
// stylesheet that measures in `ch` — see the header of fonts.css for why that matters.
import "./fonts.css";
// UI-004: the ONE global focus-visible rule. Imported once, here, so every screen inherits it —
// inline style objects cannot express a pseudo-class, which is why no control had a ring before.
// THE TOKENS, FIRST (2026-10-18). The `--vb-*` layer that opened `app.css` is its own file now,
// shared byte-for-byte with the legacy page (`/assets/vb-tokens.css`). Imported before app.css so
// the cascade order is exactly what it was when the two were one file.
import "./tokens.css";
import "./app.css";
/* The approved prototypes' stylesheet, ported whole and scoped under `.vb-ui`. Imported AFTER
   app.css so its rules win inside the wrapper; everything outside is untouched. */
import "./mock-design.css";
// THE DESIGN-TOKEN BRIDGE MOVED INTO THE CASCADE (2026-09-01). It used to be applied here as
// INLINE custom properties on `<html>`, which is why this client had no dark mode: an inline
// custom property outranks every author rule, so `@media (prefers-color-scheme: dark)` could never
// win. The `--vb-*` names are now declared in `app.css`'s `:root` block — imported above, so the
// lazily-loaded CRM chunk still finds them already set — and a parity check asserts they match
// `cssBridge` exactly. `applyCssBridge` is still exported for callers that want the values on a
// specific element; it is simply not what paints the document any more.
//
// What runs here instead is the THEME CHOICE: light / dark / system, read from localStorage and
// stamped as `data-theme` before the first paint so there is no flash of the wrong scheme.
import { applyThemeChoice, readThemeChoice } from "./design-tokens";

const container = document.getElementById("root");
if (!container) throw new Error("#root not found");

applyThemeChoice(readThemeChoice());

ReactDOM.createRoot(container).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
